'use client';

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import classNames from '@wilkins-software/classnames-tailwind-merge';
import { useNavigation } from './NavigationContext';
import { MenuItems } from './menu-items';
import { NavItem } from './navItem';
import { NAV_ITEMS } from './NAV_ITEMS';

function NavMenuList({ instanceKey }: { instanceKey: string }) {
  return (
    <MenuItems>
      {NAV_ITEMS.map((item, index) => (
        <NavItem
          key={`${instanceKey}-nav-item-${index}`}
          item={item}
          idx={index}
        />
      ))}
    </MenuItems>
  );
}

export function Menu() {
  const { isMenuOpen, setIsMenuOpen } = useNavigation();
  const [canUseDomPortal, setCanUseDomPortal] = useState(false);

  useEffect(() => {
    setCanUseDomPortal(true);
  }, []);

  useEffect(() => {
    if (!isMenuOpen) {
      return;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isMenuOpen, setIsMenuOpen]);

  const mobileOverlay =
    canUseDomPortal &&
    createPortal(
      <div
        id="menu-collapse"
        data-open={isMenuOpen ? 'true' : 'false'}
        className={classNames(
          'fixed inset-x-0 top-[4.25rem] bottom-0 z-[55] flex flex-col lg:hidden',
          'bg-gradient-to-b from-white via-white/95 to-primary/5 backdrop-blur-2xl',
          'transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]',
          isMenuOpen
            ? 'pointer-events-auto visible translate-y-0 opacity-100'
            : 'pointer-events-none invisible -translate-y-2 opacity-0',
        )}
      >
        <div className="flex min-h-0 flex-1 flex-col justify-start overflow-y-auto overscroll-contain px-5 pb-10 pt-6">
          <NavMenuList instanceKey="mobile" />
        </div>
      </div>,
      document.body,
    );

  return (
    <>
      <div className="hidden lg:block" id="menu-collapse-desktop">
        <NavMenuList instanceKey="desktop" />
      </div>
      {mobileOverlay}
    </>
  );
}
